import UltMeta, { Meta } from "./UltMeta/index";

class YesOrNo extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}
export const YES_OR_NO = new YesOrNo();
